import { ILabelStyle } from '@ardoq/yfiles';

export const GROUP_SUB_LABEL_KIND = 'groupSubLabel';
export const OPEN_GROUP_OTHER_LABEL_KIND = 'openGroupOtherLabel';

export type GroupHeaderLabelKind =
  | typeof GROUP_SUB_LABEL_KIND
  | typeof OPEN_GROUP_OTHER_LABEL_KIND;

export const getGroupHeaderLabelKind = (
  style: ILabelStyle
): GroupHeaderLabelKind | undefined =>
  (style as { groupHeaderLabelKind?: GroupHeaderLabelKind } | null)
    ?.groupHeaderLabelKind;
